export const en = {
  m: {
    createConference: "Create conference",
    startConference: "Start conference",
    conferenceLinkHint: "The conference link has been copied to the clipboard.",
    motivateHint: "You can send it to participants using the share button in the browser.",
  },
  preferences: {
    title: "Settings",
    enterYourName: "Enter your name",
    errorNameMustBeNotEmpty: "Name cannot be empty",
    errorNameMustNotTooLongBegin: "Name cannot be longer",
    errorNameMustNotTooLongEnd: "characters",
    errorAllowOnlyLettersAndSpaces: "Only letters, digits and spaces are allowed",
    cameraLabel: "Camera",
    microphoneLabel: "Microphone",
    noCameras: "No cameras found",
    noMicrophones: "No microphones found",
    defaultCameraName: "Camera {index}",
    defaultMicrophoneName: "Microphone {index}",
    micTestButton: "Test microphone",
    micTestStopButton: "Stop recording",
    micTestStopPlaybackButton: "Stop playback",
    micTestSpeak: "Speak, recording in progress.",
    micTestPlayback: "Playing back",
    micTestNoAudio: "No microphone detected",
    micTestNotSupported: "Microphone test is not supported in this browser",
    micTestProgressHint: "0 — {seconds}s"
  },
  access: {
    error: 'No access to camera/microphone',
    request: 'Request access',
    suggest: 'If the access request key does not work, check if there is a restriction in your browser settings. After changing the settings, it is recommended to restart the browser and re-enter the site.'
  }
}
